export const migrateZeitgeistDeviceBox = (boxGraph, box, grooveTarget) => {
    if (box.groove.targetAddress.isEmpty()) {
        console.debug("Migrate 'ZeitgeistDeviceBox' to GrooveShuffleBox");
        boxGraph.beginTransaction();
        box.groove.refer(grooveTarget);
        boxGraph.endTransaction();
    }
};
